import React, { useState } from "react";
import { Container, Navbar, Offcanvas } from "react-bootstrap";
import "../../AdminLayout.css";
import { FaCircleUser } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setFabricModal, setSizeModal } from "../../API/Reducer/fabricReducer";
import { setProductCatgModal } from "../../API/Reducer/productCategoryReducer";
import { CiLogout } from "react-icons/ci";
import { deleteCookieFromDB } from "../../MIS/indexedDBUtils";
import { handleUserSetLocalStorage } from "../../MIS/Global";
import FabricMaster from "../../Components/Fabric/FabricMaster";
import SizeMaster from "../../Components/Fabric/SizeMaster";
import CategoryPage from "../Admin/Category.jsx/CategoryPage";
import SidebarMenu from "../NavBar/SidebarMenu";
import { FaBars } from "react-icons/fa";
import SublimationSizeModal from "../Admin/SublimationSize/SublimationSizeModal";
import AddonsModal from "../Addons/AddonsModal";

function AdminNavbar() {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  return (
    <>
      <Navbar style={{backgroundColor:'#105c7d',color:'#fff'}}
        expand={false} className="admin-layout">
        <Container fluid>        
          <span 
            type="button"
            onClick={handleShow} 
            className="custom-toggler"
            aria-label="Toggle navigation"
            >
            <FaBars size={24} color="#fff" /> {/* Adjust color & size here */}
          </span>
          <Navbar.Offcanvas
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
            placement="start"            
            style={{ width: "250px", backgroundColor: "#136E95", color: "white" }}
            show={showOffcanvas}
            onHide={handleClose}
          >
           
            <Offcanvas.Header closeButton style={{ backgroundColor: "#136E95", borderBottom: "1px solid #ffffff22" }}>
              <Offcanvas.Title id="offcanvasNavbarLabel" style={{ color: "white" }}>
                Teeblanka
              </Offcanvas.Title>
           </Offcanvas.Header>
            <Offcanvas.Body>
             <SidebarMenu closeModal={handleClose}/>
            
            </Offcanvas.Body>
          </Navbar.Offcanvas>
          <CiLogout
            onClick={async () => {
              await deleteCookieFromDB("jcToken");
              handleUserSetLocalStorage([], "udata", true);
              navigate("/admin");
            }}
            style={{ cursor: "pointer", fontSize: "25px", color:'#fff' }}
          />
        </Container>
      </Navbar>
      <FabricMaster />
      <SizeMaster />
      <CategoryPage />
      <SublimationSizeModal/>
      <AddonsModal/>
    </>
  );
}

export default AdminNavbar;
